import classNames from 'classnames';
import type { IntlKey } from 'locales';
import { FC } from 'react';
import { useIntl } from 'react-intl';

interface OpenInLifecycleProps {
  className: string;
  labelKey: IntlKey;
  onClick: () => void;
}

export const OpenInLifecycleButton: FC<OpenInLifecycleProps> = ({ className, labelKey, onClick }) => {
  const { formatMessage } = useIntl();

  return (
    <button
      type="button"
      className={classNames('btn btn-xl btn-discreet-secondary', className)}
      onClick={onClick}
      data-e2e="open-in-lifecylcle"
    >
      {formatMessage({ id: labelKey })}
      <em className="icon icon-md ms-2">launch</em>
    </button>
  );
};
